"use strict";

//import React from "react";
import { destinosHoteles } from "../old/constans";
import apicommon from '../common/services/liferay/apicommon.js';

// Función helper para normalizar URLs y evitar problemas como doble barras
// Preserva el protocolo (https:// o http://) y solo normaliza las barras después
function normalizeUrl(url) {
    if (!url) return url;
    // Reemplazar múltiples barras consecutivas con una sola, preservando https:// o http://
    return url.replace(/([^:]\/)\/+/g, '$1');
}

async function getConfiguracion(key) {
    var promesaUrl = await apicommon('o/c/vivaconfiguracions/scopes/' + Liferay.ThemeDisplay.getScopeGroupId() + '?fields=valor&filter=clave%20eq%20%27' + key + '%27')
        .catch((e) => console.error("Error en llamada url formulario: " + e));
    var final = await promesaUrl.json();
    var url = final.items[0].valor;
    return url;
}
export default class MotorReservas {
    initialState = {
        destino: '',
        coddestino: '',
        entrada: '',
        salida: '',
        occupancies: [
            {
                adults: 2,
                children: 0,
                ages: ""
            }
        ],
        codpromo: ''
    };
    setCodPromo(cod) {
        this.initialState.codpromo = cod
    }

    setAdults(v) {
        if (typeof v === "function") {
            this.initialState.occupancies[0].adults = v(this.initialState.occupancies[0].adults);
        }
        else
            this.initialState.occupancies[0].adults = v;
    }
    setKids(v) {
        if (typeof v === "function") {
            this.initialState.occupancies[0].children = v(this.initialState.occupancies[0].children);
        }
        else
            this.initialState.occupancies[0].children = v;
        
        // Limpiar ages cuando no hay niños
        if (this.initialState.occupancies[0].children === 0) {
            this.initialState.occupancies[0].ages = "";
        }
    }

    setAges(v) {
        if (typeof v === "function") {
            this.initialState.occupancies[0].ages = v(this.initialState.occupancies[0].ages);
        }
        else
            this.initialState.occupancies[0].ages = v;
        
    }

    getAges() {
        return this.initialState.occupancies[0].ages
    }

    getAdults() {
        return this.initialState.occupancies[0].adults
    }

    getKids() {
        return this.initialState.occupancies[0].children
    }
    getHotel() {
        if (initialState.destino === '' || initialState.coddestino === '') {
            return;
        } else {
            return {
                coddestino: initialState.coddestino,
                destino: initialState.destino
            };
        }
    }
    getFechas() {
        var dates = [];
        if (initialState.entrada === '' || initialState.salida === '') {
            return;
        } else {
            dates = [
                new Date(initialState.entrada),
                new Date(initialState.salida)
            ];
        }
        return {
            entrada: dates[0],
            salida: dates[1]
        };
    }
    getOcupacion() {
        return initialState.occupancies[0];
    }


    getCodigo() {
        return initialState.codpromo;
    }

    cambioHotel(id) {
        this.resetHotelData();
        this.currentHotel = id;
        this.initialState.coddestino = id
    }
    resetHotelData() {
        this.initialState = {
            destino: '',
            coddestino: '',
            entrada: '',
            salida: '',
            occupancies: [
                {
                    adults: 2,
                    children: 0,
                    ages: ""
                }
            ],
            codpromo: ''
        };
    }
    incrementarAdults() {
        //var currentHotel = document.getElementById("dropdownHotelSelect").value;
        var hotel = destinosHoteles.filter((h) => h.codigo == this.currentHotel);
        if (hotel.length > 0) {
            if (this.initialState.occupancies[0].adults < hotel[0].maxAdultos && this.initialState.occupancies[0].adults + this.initialState.occupancies[0].children < hotel[0].maxPersonas)
                this.setAdults(adults => adults + 1);
            if (!hotel[0].ninos)
                this.setKids(kids => 0);
        } else {
            if (this.initialState.occupancies[0].children + this.initialState.occupancies[0].adults < 7 && this.initialState.occupancies[0].adults < 5)
                this.setAdults(adults => adults + 1);
        }
    }

    incrementarKids() {
        // var currentHotel = document.getElementById("dropdownHotelSelect").value;
        var hotel = destinosHoteles.filter((h) => h.codigo == this.currentHotel);
        if (hotel.length > 0) {
            if (hotel[0].ninos) {
                var limiteKids =
                    typeof hotel[0].maxNiños !== "undefined"
                        ? hotel[0].maxNiños
                        : hotel[0].maxPersonas - this.initialState.occupancies[0].adults;


                if (this.initialState.occupancies[0].children < limiteKids) {
                    this.setKids(k => k + 1);
                }

            }
        } else {
            if (this.initialState.occupancies[0].children + this.initialState.occupancies[0].adults < 7)
                this.setKids(kids => kids + 1);
        }
    }

    decrementarAdults() {
        if (this.initialState.occupancies[0].adults > 1) {
            this.setAdults(adults => adults - 1);
        }

        // var currentHotel = document.getElementById("dropdownHotelSelect").value;
        var hotel = destinosHoteles.filter((h) => h.codigo == this.currentHotel);
        if (hotel.length > 0) {
            if (!hotel[0].ninos)
                this.setKids(kids => 0);
        }
    }

    decrementarKids() {
        if (this.initialState.occupancies[0].children > 0) {
            this.setKids(kids => kids - 1);
        }
    }
    async handleSubmit() {
        var urlRoiback = await getConfiguracion("url-roiback-" + Liferay.ThemeDisplay.getLanguageId());

        if (!urlRoiback || urlRoiback == "") {
            var urlRoi = "https://";

            if (Liferay.ThemeDisplay.getLanguageId() == "es_ES")
                urlRoi += "reservas.hotelsviva.com";
            else if (Liferay.ThemeDisplay.getLanguageId() == "en_US")
                urlRoi += "booking.hotelsviva.com";
            else if (Liferay.ThemeDisplay.getLanguageId() == "de_DE")
                urlRoi += "reservierungen.hotelsviva.com";

            return this.submitSearchParameters(urlRoi);
        } else {
            return this.submitSearchParameters(urlRoiback);
        }
    }

    submitSearchParameters(urlRoiback) {
        console.log(this.initialState);
        const errors = [];

        // Validar que hay un hotel seleccionado
        if (!this.initialState.coddestino || this.initialState.coddestino === "codHotel" || this.initialState.coddestino === '') {
            console.error('Error: No hay hotel seleccionado');
            errors.push(1); // Código de error: falta seleccionar hotel
        }

        // Validar que hay al menos un adulto
        if (this.initialState.occupancies[0].adults <= 0) {
            console.error('Error: Debe haber al menos un adulto');
            errors.push(2); // Código de error: falta al menos un adulto
        }

        //date-range-redesing
        //date-range
        var datesSelected = document.getElementById("date-range-redesing")?.value;
        var url = ""
        
        // Si no hay fechas seleccionadas, establecer fechas por defecto
        if (!datesSelected || datesSelected === "") {
            var today = new Date();
            var tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            
            var dd = String(tomorrow.getDate()).padStart(2, '0');
            var mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
            var yyyy = tomorrow.getFullYear();
            var fechaEntrada = dd + '/' + mm + '/' + yyyy;
            
            var dd2 = String(tomorrow.getDate() + 1).padStart(2, '0');
            var mm2 = String(tomorrow.getMonth() + 1).padStart(2, '0');
            var yyyy2 = tomorrow.getFullYear();
            var fechaSalida = dd2 + '/' + mm2 + '/' + yyyy2;
            
            datesSelected = fechaEntrada + ' - ' + fechaSalida;
        }
        // Si hay errores de validación, retornar el array de errores
        if (errors.length > 0) {
            return errors;
        }
        
        if (datesSelected != "") {
            const dates = datesSelected.split(" - ");

            var fechaEntrada = dates[0];
            var fechaSalida = dates[1];
            
            var partesEntrada = fechaEntrada.split("/");
            var partesSalida = fechaSalida ? fechaSalida.split("/") : null;
            
            var entrada = partesEntrada[2] + "-" + partesEntrada[1] + "-" + partesEntrada[0];
            
            if (!fechaSalida) {
                var tomorrow = new Date(entrada);
                tomorrow.setDate(tomorrow.getDate() + 1);
                var date = tomorrow.getDate();
                var month = tomorrow.getMonth() + 1;
                var year = tomorrow.getFullYear();
                fechaSalida = ((date < 10) ? "0" + date : date) + "/" + ((month < 10) ? "0" + month : month) + "/" + year;
                partesSalida = fechaSalida.split("/");
            }

            var salida = partesSalida[2] + "-" + partesSalida[1] + "-" + partesSalida[0];

            this.initialState.entrada = entrada;
            this.initialState.salida = salida;

            var hotel = destinosHoteles.filter((h) => h.codigo == this.initialState.coddestino);
            if (!hotel[0].ninos) {
                this.initialState.occupancies[0].children = 0;
                this.initialState.occupancies[0].ages = "";
            }

            url = urlRoiback + '/bookcore/availability/' + this.initialState.coddestino + "/" + this.initialState.entrada + "/" + this.initialState.salida + "/?cp=" + this.initialState.codpromo + "&rrc=1&adults=" + this.initialState.occupancies[0].adults + ((this.initialState.occupancies[0].children > 0) ? "&ninos=" + this.initialState.occupancies[0].children + "&children-ages=" + this.initialState.occupancies[0].ages.replaceAll(";", ",") : "") + "&occupancies=" + encodeURIComponent(JSON.stringify(this.initialState.occupancies)) + "&occp=1";
        }
  

        const analyticsData = Object.fromEntries(
        Object.entries({
            'destino': this.initialState.destino,
            'coddestino': this.initialState.coddestino,
            'entrada': this.initialState.entrada,
            'salida': this.initialState.salida,
            'huespedes_adultos': this.initialState.occupancies[0].adults,
            'huespedes_ninos': this.initialState.occupancies[0].children,
            'huespedes_edades': Array.isArray(this.initialState.occupancies[0].ages) 
                ? this.initialState.occupancies[0].ages.join(',') 
                : this.initialState.occupancies[0].ages,
            'codpromo': this.initialState.codpromo,
            'origen': window.location.href,
            'idioma': Liferay.ThemeDisplay.getLanguageId()
        }).filter(([_, value]) => value !== null && value !== undefined && value !== '')
    );

    Analytics.track('MOTOR_RESERVAS_HOTEL', analyticsData);
        window.location.href = normalizeUrl(url);
        return []; // Array vacío: éxito
    }

}